module.exports = __webpack_public_path__ + "resources/img/img_ahnlabv3_net_server_m.1b65f192d59faf220c0392d356c3b41b.png";